import { PropsWithChildren } from 'react';

import { IconButton } from '@monoimin/atoms';

import { CarouselButton } from './CarouselButton';

type ModalInterfaceProps = PropsWithChildren<{
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}>;

export const ModalInterface = ({
  children,
  onClose,
  onNext,
  onPrev,
}: ModalInterfaceProps) => {
  return (
    <>
      <CarouselButton
        onClick={onPrev}
        direction='left'
        className='left-5 absolute bg-opacity-40 hover:bg-opacity-100 duration-150 ease-in-out -translate-y-1/2 top-1/2 hidden sm:flex'
      />
      <CarouselButton
        onClick={onNext}
        direction='right'
        className='right-5 absolute bg-opacity-40 hover:bg-opacity-100 duration-150 ease-in-out -translate-y-1/2 top-1/2 hidden sm:flex'
      />
      <IconButton
        className='rounded-full bg-black bg-opacity-40 hover:bg-opacity-100 flex items-center justify-center absolute right-5 top-5 duration-150 ease-in-out flex-shrink-0 w-12 h-12 z-20'
        onClick={onClose}
        iconProps={{
          icon: 'close',
          isInteractive: true,
          className: 'bg-white',
          sizeClassName: 'h-6 w-6',
        }}
      />
      {children}
    </>
  );
};
export default ModalInterface;
